import { ZAttrRule, ZAttrRulePattern } from "src/business/attribute/ZAttrRule";
import { onError } from "src/common/onError";
import { parseRegExp } from "src/common/parseRegExp";
import { castToFiles } from "src/components/MdmUploader/castToFiles";

import { MfValidator } from "./MfValidator";

/* eslint consistent-return: "off" */
/* eslint default-case: "off" */

export const createValidator = (rule: ZAttrRule): MfValidator => {
  switch (rule.type) {
    case "min":
      return {
        test: async (node) => {
          const { value } = node;
          if (typeof value === "number" && value < rule.minValue) {
            throw Error(rule.msg || `Минимальное значение = ${rule.minValue}`);
          }
        },
      };
    case "max":
      return {
        test: async (node) => {
          const { value } = node;
          if (typeof value === "number" && value > rule.maxValue) {
            throw Error(rule.msg || `Максимальное значение = ${rule.maxValue}`);
          }
        },
      };
    case "pattern":
      return createPattern(rule);
    case "email":
      return {
        test: async (node) => {
          const { value } = node;
          if (
            value &&
            typeof value === "string" &&
            !/^[^@]+@[^@]+$/.test(value)
          ) {
            throw Error(rule.msg || "Неправильный e-mail");
          }
        },
      };
    case "file":
      return {
        test: async (node) => {
          const { value } = node;
          const msg = castToFiles(value)?.find(
            ({ errorMsg }) => !!errorMsg,
          )?.errorMsg;
          if (msg) throw Error(msg);
        },
      };
  }
};

const createPattern = (rule: ZAttrRulePattern): MfValidator => {
  let regExp: RegExp | undefined;
  try {
    regExp = parseRegExp(rule.pattern);
  } catch (e) {
    onError(e);
  }
  return {
    test: async (node) => {
      const { value } = node;
      if (value && typeof value === "string" && regExp) {
        if (!regExp.test(value)) {
          throw Error(rule.msg || `Не соответствует шаблону ${rule.pattern}`);
        }
      }
    },
  };
};
